import { Action, Reducer } from 'redux';

// actions
import { 
    PractitionerConsumptionToSettleGetAllRequestAction,
    PractitionerConsumptionToSettleGetAllSuccessAction,
    PractitionerConsumptionToSettleGetAllFailureAction
 } from '../../actions/PractitionerConsumption.Actions';

import { PractitionerState, PractitionerUnloadState } from '../../states/PractitionerState';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { PractitionerConsumption } from '../../../models/Entities/Practitioners/PractitionerConsumption';


type KnownAction =
    PractitionerConsumptionToSettleGetAllRequestAction |
    PractitionerConsumptionToSettleGetAllSuccessAction |
    PractitionerConsumptionToSettleGetAllFailureAction;

const PractitionerConsumptionToSettleReducer: Reducer<PractitionerState> = (
  state: PractitionerState | undefined,
  incomingAction: Action
): PractitionerState => {

    if (state === undefined) {
    return PractitionerUnloadState as PractitionerState;
    }

    let CurrentPractitioner: Practitioner | undefined = undefined
    let CurrentConsumption: PractitionerConsumption | undefined = undefined

    const action = incomingAction as KnownAction;

    

    switch (action.type) {
        case 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_REQUEST':
            
            CurrentPractitioner = state.list.find((practitioner: Practitioner) => practitioner.userId === action.practitionerId
            );

            if (CurrentPractitioner) {
                CurrentPractitioner.isLoadingConsumptionToSettle = true;
                CurrentPractitioner.loadedConsumptionToSettleSuccessfully = undefined;
                CurrentPractitioner.failOnLoadConsumptionToSettle = false;
                CurrentPractitioner.errorOnLoadConsumptionToSettle = undefined;
            }

            return {
                ...state,
                list: CurrentPractitioner ? [...(state.list ?? []).filter((practitioner: Practitioner) => practitioner.userId !== CurrentPractitioner?.userId), CurrentPractitioner ] : [...state.list],
            };
    
        case 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_SUCCESS':
            CurrentPractitioner = state.list.find((practitioner: Practitioner) => practitioner.userId === action.practitionerId
            );

            if (CurrentPractitioner) {
                CurrentPractitioner.isLoadingConsumptionToSettle = false;
                CurrentPractitioner.loadedConsumptionToSettleSuccessfully = true;
                CurrentPractitioner.failOnLoadConsumptionToSettle = false;
                CurrentPractitioner.errorOnLoadConsumptionToSettle = undefined;
                CurrentPractitioner.consumptionToSettle = action.consumptions
            }

            return {
                ...state,
                list: CurrentPractitioner ? [...(state.list ?? []).filter((practitioner: Practitioner) => practitioner.userId !== CurrentPractitioner?.userId), CurrentPractitioner ] : [...state.list],
            };
    
        case 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_FAILURE':
            
            CurrentPractitioner = state.list.find((practitioner: Practitioner) => practitioner.userId === action.practitionerId
            );

            if (CurrentPractitioner) {
                CurrentPractitioner.isLoadingConsumptionToSettle = false;
                CurrentPractitioner.loadedConsumptionToSettleSuccessfully = false;
                CurrentPractitioner.failOnLoadConsumptionToSettle = true;
                CurrentPractitioner.errorOnLoadConsumptionToSettle = action.error;
            }

            return {
                ...state,
                list: CurrentPractitioner ? [...(state.list ?? []).filter((practitioner: Practitioner) => practitioner.userId !== CurrentPractitioner?.userId), CurrentPractitioner ] : [...state.list],
            };
    
    default:
        return state;
    }
};

export default PractitionerConsumptionToSettleReducer;
